/**
 * 페이지네이션 결과를 위한 인터페이스
 * T: 페이지네이션 적용할 항목의 타입
 */
export interface IPagination<T> {
  items: T[]; // 현재 페이지의 항목 배열
  page: number; // 현재 페이지 번호
  limit: number; // 페이지당 항목 수
  totalCount: number; // 전체 항목 수
}

/**
 * 페이지네이션 요청 파라미터 인터페이스
 */
export interface IPaginationParams {
  page?: number; // 요청할 페이지 번호
  limit?: number; // 페이지당 항목 수
}

/**
 * 페이지네이션 정보 계산을 위한 유틸리티 함수
 * @param pagination 페이지네이션 객체
 * @returns 계산된 페이지네이션 정보
 */
export const getPaginationInfo = (pagination: IPagination<any>) => {
  const { page, limit, totalCount } = pagination;

  const totalPages = Math.ceil(totalCount / limit);
  const hasNextPage = page < totalPages;
  const hasPrevPage = page > 1;

  return {
    totalPages,
    hasNextPage,
    hasPrevPage,
    currentPage: page,
    isFirstPage: page === 1,
    isLastPage: page === totalPages,
  };
};
